(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["pkj-top-models"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('pk-product-carousel')) {
  customElements.define('pk-product-carousel', class extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('[data-pk-product-track]');
      this.controls = this.querySelector('[data-pk-product-controls]');
      this.previous = this.querySelector('[data-pk-product-prev]');
      this.next = this.querySelector('[data-pk-product-next]');
      if (!this.track || !this.controls || !this.previous || !this.next) return;
      this.cards = Array.from(this.track.querySelectorAll('.pkj-top-model'));
      this.abort = new AbortController();
      const signal = this.abort.signal;
      this.controls.hidden = this.cards.length < 2;
      this.previous.addEventListener('click', () => this.move(-1), { signal });
      this.next.addEventListener('click', () => this.move(1), { signal });
      this.track.addEventListener('keydown', event => {
        if (event.target !== this.track) return;
        if (event.key === 'ArrowLeft' || event.key === 'ArrowRight') {
          event.preventDefault();
          this.move(event.key === 'ArrowLeft' ? -1 : 1);
        } else if (event.key === 'Home' || event.key === 'End') {
          event.preventDefault();
          this.go(event.key === 'Home' ? 0 : this.cards.length - 1);
        }
      }, { signal });
      this.track.addEventListener('scroll', () => {
        cancelAnimationFrame(this.frame);
        this.frame = requestAnimationFrame(() => this.update());
      }, { passive: true, signal });
      this.addEventListener('shopify:block:select', event => {
        const card = event.target.closest('.pkj-top-model');
        const index = this.cards.indexOf(card);
        if (index >= 0) this.go(index, 'auto');
      }, { signal });
      if ('ResizeObserver' in window) {
        this.resize = new ResizeObserver(() => this.update());
        this.resize.observe(this.track);
      } else {
        window.addEventListener('resize', () => this.update(), { signal });
      }
      this.update();
    }
    disconnectedCallback() {
      if (this.abort) this.abort.abort();
      if (this.resize) this.resize.disconnect();
      cancelAnimationFrame(this.frame);
    }
    move(direction) {
      const position = this.track.scrollLeft;
      let nearest = 0;
      this.cards.forEach((card, index) => {
        if (Math.abs(card.offsetLeft - position) < Math.abs(this.cards[nearest].offsetLeft - position)) nearest = index;
      });
      this.go(nearest + direction);
    }
    go(index, behavior) {
      const card = this.cards[Math.max(0, Math.min(index, this.cards.length - 1))];
      if (!card) return;
      this.track.scrollTo({
        left: card.offsetLeft,
        behavior: behavior || (window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth')
      });
    }
    update() {
      const limit = Math.max(0, this.track.scrollWidth - this.track.clientWidth);
      this.previous.disabled = this.track.scrollLeft <= 2;
      this.next.disabled = this.track.scrollLeft >= limit - 2;
      this.controls.hidden = limit <= 2;
    }
  });
}

  } catch(e) { console.error(e); }
})();
})();
